import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";

interface StreamModalProps {
  open: boolean;
  initial: { title: string; url: string };
  mode: "add" | "edit";
  onClose: () => void;
  onSave: (title: string, url: string) => void;
}

export default function StreamModal({
  open,
  initial,
  mode,
  onClose,
  onSave,
}: StreamModalProps) {
  const [title, setTitle] = useState(initial.title);
  const [url, setUrl] = useState(initial.url);

  const handleEnter = () => {
    setTitle(initial.title);
    setUrl(initial.url);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionProps={{ onEnter: handleEnter }}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, fontSize: "16px", pb: 1 }}>
        {mode === "add" ? "Add Stream Example" : "Edit Stream Example"}
      </DialogTitle>

      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "8px !important" }}
      >
        <TextField
          fullWidth
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g., Celebration of Life - John Doe"
          size="small"
          autoFocus
        />
        <TextField
          fullWidth
          label="Page URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://mms.muzukuru.com/..."
          size="small"
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} color="inherit" size="small">
          Cancel
        </Button>
        <Button
          onClick={() => onSave(title, url)}
          variant="contained"
          size="small"
          disabled={!title.trim() || !url.trim()}
          sx={{ bgcolor: "#724e41", "&:hover": { bgcolor: "#5d3e33" } }}
        >
          {mode === "add" ? "Add" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}